import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=2844fa65"
import script from "./Birthdays.vue?vue&type=script&lang=js"
export * from "./Birthdays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports